<template>
  <div class="index">
    <!-- 头部内容 -->
    <div class="headerBox">
      <div class="w1200 recruitHeader">
        <div class="recruitInfo">
          <p class="recruitName">{{recruitData.jobName}}</p>
          <p class="recruitXizi">待遇:<span class="money">{{recruitData.salary}}</span></p>
          <p class="recruittips">
            <span v-for="(x,i) in headerLeftInfo" :key="i">{{x.label}}: {{recruitData[x.key]}}</span>
          </p>
        </div>
        <div class="recruitBtns">
          <p class="tips">
            <span style="cursor: pointer;" @click="collectHandler()">
              <i class="iconfont" :style="isCollected?'color:red;':''">{{'\ue60b'}}</i>收藏
            </span>
            <span>
              <i class="iconfont">{{'\ue618'}}</i>{{recruitData.viewTime}}次
            </span>
            <span>
              <i class="iconfont">{{'\ue6ce'}}</i>{{recruitData.createTime}}
            </span>
          </p>
          <p class="btns">
            <span><el-button type="danger" @click="applyJob">申请职位</el-button></span>
            <span><a href="https://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/JCGF_for_Windows.exe"><el-button type="primary">视频面试</el-button></a></span>
          </p>
        </div>
      </div> 
    </div>
    <!-- 招聘信息 -->
    <div class="mainBox w1200">
      <div class="leftBox">
        
        <div style="margin-bottom: 20px;border: 1px solid #eee;">
          <div class="bigBox" v-for="(x,i) in mainLeftInfo" :key="i">
            <p>{{x.label}}</p>
            <div class="dataInfo" v-if="x.children">
              <ul>
                <li v-for="(x2,i2) in x.children" :key="i2">
                  <span class="titleSpan">{{x2.label}}：</span>
                  <span class="valSpan" style="padding:0 15px">{{companyData.o_vipType||!i?recruitData[x2.key]:'****'}}</span>
                </li>
              </ul>
            </div>
            <div class="dataInfo" v-else>{{recruitData[x.key]}}</div>
          </div>
          <div class="bigBox">
            <p>企业名片</p>
            <div class="dataInfo">
              <div v-for="(x,i) in cardInfo" :key="i" style="padding: 5px 0px;">
                <span class="titleSpan">{{x.label}}：</span>
                <span class="valSpan" style="padding:0 15px">{{companyData.o_vipType?companyData[x.value]:'****'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="otherRecruit">
          <p class="title">看了此职位的人还会看</p>
          <ul>
            <li v-for="(x,i) in mainLeftOther" :key="i" @click="goOtherRecruit(x.organizationName,x.id)">
              <p class="recruitTitle textoverhiden">{{x.jobName}}</p>
              <p class="xinzi textoverhiden">{{x.salary}}</p>
              <p class="oname textoverhiden">{{x.organizationName}}</p>
            </li>
          </ul>
        </div>

      </div>
      <div class="rightBox">
        <!-- 企业信息 -->
        <div class="companyInfo">
          <ul v-if="companyData">
            <li class="imgTitle">
              <div class="imgbox"><img :src="companyData.o_homeUrl|toimg"/></div>
              <div class="titlebox">{{companyData.o_name}}</div>
            </li>
            <li class="compantInfoList" v-for="(x,i) in mainRightCompanyInfo" :key="i">
              <span style="margin-right:10px">{{x.label}}:</span>
              <span>{{companyData[x.key]}}</span>
            </li>
            <li class="btnBox" @click="lookCompany('home')">查看企业更多信息</li>
          </ul>
          <ul v-if="companyData == undefined">未能获取到企业信息</ul>
        </div>
        <!-- 更多职位 -->
        <div class="companyOtherInfo">
          <p class="titlebox"><span class="big">该公司的其他职位</span><span class="small" @click="lookCompany('job')">其他</span></p>
          <ul v-if="mainRightCompanyOtherInfo.length!=0">
            <li v-for="(x,i) in mainRightCompanyOtherInfo" :key="i" @click="goOtherRecruit(x.organizationName,x.id)">
              <p class="name textoverhiden">{{x.jobName}}</p>
              <p class="money textoverhiden">{{x.salary}}</p>
              <p class="address textoverhiden">{{x.address+" | "+x.education+" | "+ x.workExperience}}</p>
            </li>
          </ul>
          <ul v-else>
            <li>暂无其他职位</li>
          </ul>
        </div>
        <!-- 广告位 -->
        <!-- <div class="otherInfo">
          <advertisement imgwidth="320px" imgheight="160px"></advertisement>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '@/Mixins/mixin_3g48'
import advertisement from '@/views/showpage/components/advertisement'
export default {
  components: { advertisement , mixins},
  data() {
    return {
      mainLeftOther: [],
      mainRightCompanyOtherInfo: [],
      
      recruitData: {},//招聘职位data
      companyData: {},//招聘职位公司data

      cardInfo: [
        {label:'企业电话',value:'o_phone'},
        {label:'企业QQ',value:'o_QQ'},
        {label:'企业微信',value:'o_weixin'},
      ],
      headerLeftInfo: [
        {label:'工作性质',key:'workType'},
        {label:'学历',key:'education'},
        {label:'性别',key:'sex'},
        {label:'招聘人数',key:'planPersons'},
      ],
      mainLeftInfo: [
        {label:'职位信息',children: [
          {label:'工作性质',key:'workType'},
          {label:'职位类别',key:'jobType'},
          {label:'招聘方式',key:'recruitStyle'},
          {label:'性别要求',key:'sex'},
          {label:'招聘部门',key:'department'},
          {label:'学历要求',key:'education'},
          {label:'工作经验',key:'workExperience'},
          {label:'工作地点',key:'address'},
        ]},
        {label:'职位描述',key:'description'},
        {label:'任职要求',key:'requirement'},
        {label:'面试须知',key:'interview'},
        {label:'联系方式',children: [
          {label:'单位联系人',key:'contactUser'},
          {label:'联系电话',key:'phone'},
        ]},
      ],
      mainRightCompanyInfo: [
        {label:'成立日期',key:'o_publicTime'},
        {label:'注册资金',key:'o_registerCash'},
        {label:'所属行业',key:'o_domain'},
        {label:'企业性质',key:'o_type'},
        {label:'企业规模',key:'o_person'},
        // {label:'企业电话',key:'o_phone'},
      ],

      isCollected: false,
      collectedId: '',
    }
  },
  methods: {
    getCollectZhiwei() {
      let rD = {
        targetId: this.$route.query.id,
        userId: this.userInfo.id,
        type: '职位',
      }
      this.$api.util_search('shoucang', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          if (_R.length) {
            console.log(`%c已经收藏了:`, 'color: #00f;', )
            this.isCollected = true
            this.collectedId = _R[0].id
          } else {
            this.isCollected = false
            this.collectedId = ''
          }
        } else { this._status(res.data) }
      })
    },
    // 收藏职位
    collectHandler() {
      if (this.isCollected) {
        this.$api.util_delete('shoucang', { ids: [this.collectedId] }).then(res => {
          if (res.data.status == 0) {
            this.isCollected = false
          } else { this._status(res.data) }
        })
      } else {
        let rD = {
          targetId: this.$route.query.id,
          userId: this.userInfo.id,
          type: '职位',
        }
        this.$api.util_create('shoucang', rD).then(res => {
          if (res.data.status == 0) {
            this.isCollected = true
            this.getCollectZhiwei()
          } else { this._status(res.data) }
        })
      }
    },
    async initThisPage() {
      await this.getRecruitData()
      let o_name = this.recruitData.organizationName
      await this.getCompanyData(o_name)
      this.getCollectZhiwei()
      this.getSuggestJob()//获取  猜你喜欢
      this.getOtherJob(o_name)//传入公司名，查询该公司的其他职位
    },
    //获取职位信息
    getRecruitData() {
      let id = this.$route.query.id
      return this.$api.util_search('zhaopin', { id }).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          if (_R.length) {
            this.recruitData = _R[0]
            console.log(`%c请求职位:`, 'color: #f00;', _R[0])
          }
        } else { this._status(res.data) }
      })
    },
    //获取企业信息
    getCompanyData(o_name) {
      return this.$api._user_companyInfo({ o_name }).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          if (_R.length) {
            this.companyData = _R[0]
            console.log(`%c企业信息:`, 'color: #f00;', _R[0])
          }
        } else { this._status(res.data) }
      })
    },

    // 职位申请
    applyJob() {
      if (this.userInfo.personal) {
        let rD = {}
        rD.jobId = this.recruitData.id
        rD.organizationName = this.companyData.o_name
        rD.userId = this.userInfo.id
        rD.u_nickName = this.userInfo.u_nickName
        rD.u_education = this.userInfo.u_education
        rD.jobName = this.recruitData.jobName
        rD.o_name = this.companyData.o_name
        console.log(rD)
        this.$api.util_create('jianli', rD).then(res => {
          if (res.data.status == 0) {
            this.$message.success('投递成功，敬候佳音。')
          } else if (res.data.status == 19) {
            this.$message.info('不能重复申请同一个职位，请多看看其他招聘信息吧！')
          } else { this._status(res.data) }
        })
      } else {
        this.$message.info('该账号不能进行此操作！请切换为普通个人账号')
      }
    },
    // 跳转职位详情页
    goOtherRecruit(organizationName,id) {
      let url = '/recruitDetail?type=zhaopin&id='+id
      // console.log(this.$route.fullPath, url)
      if (this.$route.fullPath !== url) {
        this.$router.replace(url)
        this.initThisPage()
      }
      this.scrollToTop()
    },
    // 查看企业信息
    lookCompany(str) {
      str == 'home' ? this.$router.push('/detailList?type=companyhome&oname='+this.companyData.o_name) :''
      str == 'job' ? this.$router.push('/detailList?type=zhaopin&oname='+this.companyData.o_name) :''
    },
    //获取  猜你喜欢
    getSuggestJob() {
      let id = this.$route.query.id
      this.$api.getSuggestJob(id).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c推荐职位:`, 'color: #f00;', _R)
          this.mainLeftOther = _R
        } else { this._status(res.data) }
      })
    },
    //获取  该公司的其他职位
    getOtherJob(organizationName) {
      this.$api.util_search('zhaopin', {organizationName}).then(res=> {
        if (res.data.status == 0) {
          let arr1 = Array.from(JSON.parse(res.data.data))//.slice(0,3)
          this.mainRightCompanyOtherInfo = arr1.length > 3 ? arr1.slice(0,3) : arr1
        } else { this._status(res.data) }
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initThisPage()
    })
  },
}
</script>

<style lang='scss' scoped>
/* 招聘详情头部 */
.headerBox{padding: 20px 0px;margin-bottom: 30px;font-size: 12px;background-color: #f3f3f3;border-top: 1px solid #eeeeee;border-bottom: 1px solid #eeeeee;}

.headerBox .recruitHeader{display: flex;justify-content: space-between;}
.headerBox .recruitHeader .recruitName{font-size: 30px;display: block;line-height: 1.4;margin-bottom: 10px;}
.headerBox .recruitHeader .recruitXizi{color: #666;margin-bottom: 15px;}
.headerBox .recruitHeader .recruitXizi .money{color: #ff6b6b;font-size: 24px;margin-left: 20px;}
.headerBox .recruitHeader .recruittips{height: 32px;line-height: 32px;}
.headerBox .recruitHeader .recruittips span{border: 1px solid #eeeeee;background-color: #ffffff;border-radius: 3px;float: left;margin-right: 10px;text-align: center;padding: 0 15px;line-height: 30px;color: #666666;}
.headerBox .recruitHeader .tips{text-align: right;padding-top: 20px;}
.headerBox .recruitHeader .tips span{margin-left: 20px;}
.headerBox .recruitHeader .tips span i{margin-right: 5px;}
.headerBox .recruitHeader .btns{padding-top: 20px;}
.headerBox .recruitHeader .btns button{display: inline-block;margin-left: 20px;font-size: 16px;width: 115px;height: 44px;}

/* 中部内容 */
.mainBox{display: flex;justify-content: space-between;margin-bottom: 50px;align-items: flex-start}
.mainBox .leftBox{width: 850px;border-top: 0px;}
.mainBox .leftBox .bigBox{border-top: 1px solid #eee;}
.mainBox .leftBox .bigBox p{position: relative;padding: 0px 25px;height: 50px;line-height: 50px;font-size: 18px;}
.mainBox .leftBox .bigBox p:before{display: inline-block;position: absolute;top: 17px;left: 17px;height: 18px;width: 3px;content: '';background-color: #ec0001;}
.mainBox .leftBox .bigBox .dataInfo{padding: 0px 15px 15px 25px;font-size: 14px;color: #666666;}
.mainBox .leftBox .bigBox .dataInfo ul{display: flex;flex-wrap: wrap;justify-content: end;}
.mainBox .leftBox .bigBox .dataInfo ul li{padding: 5px 0px;width: 30%;}
.mainBox .leftBox .otherRecruit{border: 1px solid #eee;}
.mainBox .leftBox .otherRecruit .title{height: 46px;line-height: 46px;text-indent: 20px;color: #666;background-color: #f9f9f9;}
.mainBox .leftBox .otherRecruit ul{padding: 20px 20px 0px 0px;display: flex;flex-wrap: wrap;
}
.mainBox .leftBox .otherRecruit ul li{width: 224px;height: 72px;padding: 15px;margin: 0px 0px 20px 20px;display: inline-block;border: 1px solid #eee;}
.mainBox .leftBox .otherRecruit ul li:hover{box-shadow:0px 0px 10px #cccccc;cursor: pointer;}
.mainBox .leftBox .otherRecruit ul li:hover .recruitTitle{color: #1E9FFF;}
.mainBox .leftBox .otherRecruit ul li p{margin-bottom: 8px;}
.mainBox .leftBox .otherRecruit ul li .recruitTitle{min-height: 24px;color: #444;}
.mainBox .leftBox .otherRecruit ul li .xinzi{min-height: 18px;color: #ff6b6b;font-size: 12px;}
.mainBox .leftBox .otherRecruit ul li .oname{min-height: 18px;color: #666;font-size: 12px;}



.mainBox .rightBox{width: 320px;}
.mainBox .rightBox .companyInfo{font-size: 14px;color: #666;width: 290px;padding: 15px;margin-bottom: 20px;border: 1px solid #eee;}
.mainBox .rightBox .companyInfo .imgTitle{display: flex;color: #444;font-size: 18px;margin-bottom: 15px;}
.mainBox .rightBox .companyInfo .imgbox{display: inline-block;margin-right: 20px;width: 75px;height: 75px;border: 1px solid #ccc;}
.mainBox .rightBox .companyInfo .titlebox{max-width: 193px;max-height: 75px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical}
.mainBox .rightBox .companyInfo .titlebox:hover{color: #1E9FFF;cursor: pointer;}
.mainBox .rightBox .companyInfo .imgbox img{width: 75px;height: 75px;}
.mainBox .rightBox .companyInfo .compantInfoList{height: 30px;line-height: 30px;}
.mainBox .rightBox .companyInfo .btnBox{text-align: center;margin-top: 10px;border: 1px solid #C9C9C9;height: 38px;line-height: 38px;border-radius: 20px;}
.mainBox .rightBox .companyInfo .btnBox:hover{cursor: pointer;border: 1px solid #1E9FFF;}
.mainBox .rightBox .companyOtherInfo{border: 1px solid #eee;border-bottom: 0px;width: 320px;}
.mainBox .rightBox .companyOtherInfo .titlebox{display: flex;justify-content: space-between;padding: 0px 15px;height: 45px;line-height: 45px;background-color: #f9f9f9;border-bottom: 1px solid #eee;}
.mainBox .rightBox .companyOtherInfo .titlebox .big{color: #666;font-size: 16px;}
.mainBox .rightBox .companyOtherInfo .titlebox .small{color: #999;font-size: 14px;}
.mainBox .rightBox .companyOtherInfo .titlebox .small:hover{cursor: pointer;}
.mainBox .rightBox .companyOtherInfo ul{width: 290px;}
.mainBox .rightBox .companyOtherInfo ul li{width: 100%;border-bottom: 1px solid #eee;padding: 15px;}
.mainBox .rightBox .companyOtherInfo ul li:hover{cursor: pointer;}
.mainBox .rightBox .companyOtherInfo ul li:hover .name{color: #1E9FFF;}
.mainBox .rightBox .companyOtherInfo ul li p{margin-bottom: 5px;}
.mainBox .rightBox .companyOtherInfo ul li p.name{width: 290px;font-size: 16px;}
.mainBox .rightBox .companyOtherInfo ul li p.money{width: 290px;font-size: 14px;color: #ff6b6b;}
.mainBox .rightBox .companyOtherInfo ul li p.address{width: 290px;font-size: 12px;color: #666666;}
.mainBox .rightBox .otherInfo{margin-top: 20px;width: 320px;}
</style>